const PeoplePurposeHeroSection = () => {
  const awsImageBaseUrl = process.env.REACT_APP_AWS_IMAGE_BUCKET_URL; 
  return (
 <section>
      <div className="card text-white border-0 hero-card ">
        {/* Responsive image wrapper with fixed height */}
        <div className="card-img-wrapper">
          <img src={`${awsImageBaseUrl}images/PeoplePurposet/people-purpose_v2.jpg`}  className="card-img rounded-0" alt="Hero Background" />
        </div>
        {/* Overlay Content */}

  </div>  
  </section>
  );
};


export default PeoplePurposeHeroSection;